import Vue from 'vue'
import "@/../public/common.css"
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import app from "@/app.js";
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs);
import filters from './filters.js';
import VueMoment from 'vue-moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faUserSecret)
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/lv';

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueMoment)

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
// eslint-disable-next-line
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace

  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

filters.forEach(f => {
  Vue.filter(f.name, f.func)
})

//console.log(process.env)
Vue.config.productionTip = false;
//Vue.config.devtools = true;
//Vue.prototype.$filters = Vue.options.filters;
Vue.prototype.$api = app;

const vm = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}
).$mount('#app')

app.$vm = vm;


